// Fiscal Year
export const GET_FISCAL_YEARS = '/fiscal_year';
export const GET_FISCAL_YEAR_QUERY = '/fiscal_year/query';
export const GET_FISCAL_YEAR_BY_ID = '/fiscal_year/';
export const POST_FISCAL_YEAR_WITH_PERIODS = '/fiscal_year/with_periods';
export const PUT_FISCAL_YEAR = '/fiscal_year/';
export const DELETE_FISCAL_YEAR = '/fiscal_year/';
